import { HubConnection } from '@microsoft/signalr';
import { createContext } from 'react';

interface ISignalRContext {
  connection: HubConnection | undefined;
  methods: string[];
  setMethods: (arg: string) => void;
}

export const SignalRContext = createContext<ISignalRContext>({
  connection: undefined,
  methods: [],
  setMethods: methodName => {},
});
